export default {
  title: {
    en: 'Upgrade your plan',
  },
}
